import React from 'react'

import HorizontalGridDivider from '../containers/horizontalGridDivider'
import SettingForm from '../containers/setting/SettingForm'
import SettingTitleBar from '../containers/setting/SettingTitleBar'
import SideMenu from '../containers/sideMenu'
import StyledMain from '../containers/styledMain'
import TopBar from '../containers/topBar'
import VerticalGridDivider from '../containers/verticalGridDivider'

// TODO: refactor such that setting page can have multiple setting form
const Setting = () => {
  return (
    <HorizontalGridDivider>
      <SideMenu />
      <VerticalGridDivider>
        <TopBar />
        <StyledMain>
          <SettingTitleBar />
          <SettingForm />
        </StyledMain>
      </VerticalGridDivider>
    </HorizontalGridDivider>
  )
}

export default Setting
